export default __webpack_public_path__ + "static/media/potato5.58d807aa.png";